<template>
  <PageWrapper :isLoading="isLoading">
    <template #title> لیست نقش های سیستم </template>
    <template #titleBtn>
      <BButton @click="renderCreateNewRoleModal" variant="success">
        ایجاد نقش جدید
      </BButton>
    </template>
    <CustomTable
      v-if="rolesList"
      :totalCount="0"
      :tableColumns="tableColumns"
      :tableItems="rolesList"
      @changePage="() => {}"
    >
      <template #persianName="data">
        {{ data.item.title }}
      </template>
      <template #handleAccess="data">
        <div class="d-flex align-items-center">
          <BButton
            variant="transparent"
            size="sm"
            :to="`/roles/${data.item.userTypeId}`"
          >
            <FeatherIcon class="text-primary" icon="SettingsIcon" size="23" />
          </BButton>
          <BButton
            variant="transparent"
            size="sm"
            @click="renderUserTypeUpdateModal(data.item)"
          >
            <FeatherIcon icon="EditIcon" class="text-info" size="23" />
          </BButton>
          <BButton
            variant="transparent"
            size="sm"
            @click="renderUserTypeDeleteConfirmationDialog(data.item)"
          >
            <FeatherIcon icon="Trash2Icon" class="text-danger" size="23" />
          </BButton>
        </div>
      </template>
    </CustomTable>

    <UpdateRoleDialog
      :defaultUserType="tempUserType"
      @refetch="getAllRoles"
    ></UpdateRoleDialog>

    <DeleteRoleConfirmationDialog
      :selectedRole="tempUserType"
      @refetch="getAllRoles"
    ></DeleteRoleConfirmationDialog>

    <CreateNewRoleDialog @refetch="getAllRoles"></CreateNewRoleDialog>
  </PageWrapper>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      rolesList: null,
      tableColumns: [
        {
          key: "userTypeId",
          label: "شناسه نقش",
        },
        {
          key: "persianName",
          label: "نام فارسی",
        },
        {
          key: "name",
          label: "نام انگلیسی",
        },
        {
          key: "description",
          label: "توضیحات",
        },
        {
          key: "handleAccess",
          label: "عملیات",
        },
      ],
      tempUserType: null,
    };
  },
  mounted() {
    this.getAllRoles();
  },
  methods: {
    renderUserTypeUpdateModal(selectedUserType) {
      this.tempUserType = selectedUserType;
      this.$bvModal.show("update-role-dialog");
    },
    renderUserTypeDeleteConfirmationDialog(selectedUserType) {
      this.tempUserType = selectedUserType;
      this.$bvModal.show("delete-role-confirmation-dialog");
    },
    renderCreateNewRoleModal() {
      this.$bvModal.show("create-new-user-type-dialog");
    },

    async getAllRoles() {
      try {
        this.isLoading = true;
        const _this = this;
        const getAllUserTypes = new GetAllUserTypes(_this);
        await getAllUserTypes.fetch((response) => {
          _this.rolesList = response;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },

  components: {
    PageWrapper,
    CustomTable,
    UpdateRoleDialog,
    CreateNewRoleDialog,
    DeleteRoleConfirmationDialog,
    BButton,
  },
};
import PageWrapper from "@/views/components/Utils/PageWrapper.vue";
import CustomTable from "@/views/components/Utils/CustomTable.vue";
import UpdateRoleDialog from "@/views/components/Roles/UpdateRoleDialog.vue";
import DeleteRoleConfirmationDialog from "@/views/components/Roles/DeleteRoleConfirmationDialog.vue";
import CreateNewRoleDialog from "@/views/components/Roles/CreateNewRoleDialog.vue";
import { BButton } from "bootstrap-vue";
import { GetAllUserTypes } from "@/libs/Api/UserType";
</script>
